import { Anchor } from '@mantine/core';

import PasswordChangeModal from './PasswordChangeModal';

import { useModal } from '@/hooks/useModal';
import { useAuth } from '@/hooks/useAuth';

// Api
import { usePasswordChangeMutation } from '../../services/passwordChange';
import { OnSubmitFunc } from '@/types/form';

// Types
import type { PasswordChangeFields } from '../../types';

const PasswordChange = ({
  createMessage,
  className,
}: {
  createMessage: (msg: string, options: any) => void;
  className?: string;
}) => {
  const { tokenInfo } = useAuth();
  const { isPending: isSubmitting, mutate: changePassword } = usePasswordChangeMutation();
  const { Modal, modalProps, openModal, closeModal } = useModal();

  const onSubmit: OnSubmitFunc<PasswordChangeFields> = (formData, setGeneralError) => {
    const passwordPayload = {
      username: tokenInfo.sub,
      password: formData.currentPassword,
      new_password: formData.newPassword,
    };

    changePassword(passwordPayload, {
      onSuccess: () => {
        createMessage('Password changed successfully', { type: 'success' });
        closeModal();
      },
      onError: (error) => {
        setGeneralError(error);
      },
    });
  };

  return (
    <>
      <Anchor
        component="button"
        type="button"
        onClick={openModal}
        className={className}
        id="passchange-button"
        underline="always"
      >
        Change password
      </Anchor>

      <Modal {...modalProps} title="Change password" size="500px">
        <PasswordChangeModal onSubmit={onSubmit} isSubmitting={isSubmitting} />
      </Modal>
    </>
  );
};

export default PasswordChange;
